import { render, staticRenderFns } from "./SEPARATOR.vue?vue&type=template&id=356ad952&scoped=true&"
import script from "./SEPARATOR.vue?vue&type=script&lang=js&"
export * from "./SEPARATOR.vue?vue&type=script&lang=js&"
import style0 from "./SEPARATOR.vue?vue&type=style&index=0&id=356ad952&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "356ad952",
  null
  
)

export default component.exports